import { render, staticRenderFns } from "./DrugsRiskFactors.vue?vue&type=template&id=476d98c5&"
import script from "./DrugsRiskFactors.vue?vue&type=script&lang=js&"
export * from "./DrugsRiskFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports